"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _EthereumProvider_options, _EthereumProvider_api, _EthereumProvider_wallet, _EthereumProvider_executor, _EthereumProvider_blockchain, _EthereumProvider_send, _EthereumProvider_logRequest, _EthereumProvider_legacySendPayloads, _EthereumProvider_legacySendPayload;
Object.defineProperty(exports, "__esModule", { value: true });
exports.EthereumProvider = void 0;
const emittery_1 = __importDefault(require("emittery"));
const api_1 = __importDefault(require("./api"));
const utils_1 = require("@ganache/utils");
const ethereum_options_1 = require("@ganache/ethereum-options");
const lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
const wallet_1 = __importDefault(require("./wallet"));
const blockchain_1 = __importDefault(require("./blockchain"));
const fork_1 = require("./forking/fork");
const ethereum_address_1 = require("@ganache/ethereum-address");
function parseCoinbase(coinbase, initialAccounts) {
    switch (typeof coinbase) {
        case "object":
            return coinbase;
        case "number":
            const account = initialAccounts[coinbase];
            if (account) {
                return account.address;
            }
            else {
                throw new Error(`invalid coinbase address index: ${coinbase}`);
            }
        case "string":
            return ethereum_address_1.Address.from(coinbase);
        default: {
            throw new Error(`coinbase address must be string or number, received: ${coinbase}`);
        }
    }
}
/**
 * Detects when a ganache:vm:tx:step listener is active and signals the onChange
 * function when the status changes
 * @param provider -
 * @param onChange -
 */
function hookEventSystem(provider, onChange) {
    let listenerCount = 0;
    provider.on(emittery_1.default.listenerAdded, ({ eventName }) => {
        if (eventName === "ganache:vm:tx:step" || eventName === undefined) {
            if (listenerCount === 0) {
                onChange(true);
            }
            listenerCount++;
        }
    });
    provider.on(emittery_1.default.listenerRemoved, ({ eventName }) => {
        if (eventName === "ganache:vm:tx:step" || eventName === undefined) {
            listenerCount--;
            if (listenerCount === 0) {
                onChange(false);
            }
        }
    });
}
class EthereumProvider extends emittery_1.default {
    constructor(options = {}, executor) {
        super();
        _EthereumProvider_options.set(this, void 0);
        _EthereumProvider_api.set(this, void 0);
        _EthereumProvider_wallet.set(this, void 0);
        _EthereumProvider_executor.set(this, void 0);
        _EthereumProvider_blockchain.set(this, void 0);
        /**
         * Remove an event subscription
         */
        this.removeListener = this.off;
        _EthereumProvider_send.set(this, (arg1, arg2) => {
            let method;
            let params;
            let response;
            if (typeof arg1 === "string") {
                // this signature is (not) non-standard and is only a ganache thing!!!
                // we should probably remove it, but I really like it so I haven't yet.
                method = arg1;
                params = arg2;
                response = this.request({ method, params });
            }
            else if (typeof arg2 === "function") {
                // handle backward compatibility with callback-style ganache-core
                if (Array.isArray(arg1)) {
                    const callback = arg2;
                    __classPrivateFieldGet(this, _EthereumProvider_legacySendPayloads, "f").call(this, arg1).then(({ error, result }) => {
                        callback(error, result);
                    });
                }
                else {
                    const callback = arg2;
                    __classPrivateFieldGet(this, _EthereumProvider_legacySendPayload, "f").call(this, arg1).then(({ error, result }) => {
                        callback(error, result);
                    });
                }
            }
            else {
                throw new Error("No callback provided to provider's send function. As of web3 1.0, provider.send " +
                    "is no longer synchronous and must be passed a callback as its final argument.");
            }
            return response;
        });
        _EthereumProvider_logRequest.set(this, (method, params) => {
            const options = __classPrivateFieldGet(this, _EthereumProvider_options, "f");
            if (options.logging.verbose) {
                options.logging.logger.log(`   >  ${method}: ${params == null
                    ? params
                    : JSON.stringify(params, null, 2).split("\n").join("\n   > ")}`);
            }
            else {
                options.logging.logger.log(method);
            }
        });
        /**
         * Disconnect the provider instance. This will cause the underlying blockchain to be stopped, and any pending
         * tasks to be rejected. Emits a `disconnect` event once successfully disconnected.
         * @returns Fullfills with `undefined` once the provider has been disconnected.
         */
        this.disconnect = async () => {
            // executor.stop() will stop accepting new tasks, but will not wait for inflight tasks. These may reject with
            // (unhelpful) internal errors. See https://github.com/trufflesuite/ganache/issues/3499
            __classPrivateFieldGet(this, _EthereumProvider_executor, "f").stop();
            await __classPrivateFieldGet(this, _EthereumProvider_blockchain, "f").stop();
            await __classPrivateFieldGet(this, _EthereumProvider_options, "f").logging.logger.close();
            __classPrivateFieldGet(this, _EthereumProvider_executor, "f").end();
            this.emit("disconnect");
        };
        //#region legacy
        _EthereumProvider_legacySendPayloads.set(this, (payloads) => {
            return Promise.all(payloads.map(__classPrivateFieldGet(this, _EthereumProvider_legacySendPayload, "f"))).then(results => {
                let mainError = null;
                const responses = [];
                results.forEach(({ error, result }, i) => {
                    responses.push(result);
                    if (error) {
                        if (mainError == null) {
                            mainError = new Error("Batch error:");
                        }
                        mainError.errors[i] = error;
                    }
                });
                return { error: mainError, result: responses };
            });
        });
        _EthereumProvider_legacySendPayload.set(this, async (payload) => {
            const method = payload.method;
            const params = payload.params;
            try {
                const result = await this.request({ method, params });
                return {
                    error: null,
                    result: (0, utils_1.makeResponse)(payload.id, JSON.parse(JSON.stringify(result)))
                };
            }
            catch (error) {
                let result;
                // In order to provide `vmErrorsOnRPCResponse`, the `error` might have
                // a `result` property that we need to move to the result field. Yes,
                // it's super weird behavior!
                if ((0, utils_1.hasOwn)(error, "result")) {
                    result = error.result;
                    delete error.result;
                }
                return { error, result: (0, utils_1.makeError)(payload.id, error, result) };
            }
        });
        __classPrivateFieldSet(this, _EthereumProvider_executor, executor, "f");
        const providerOptions = (__classPrivateFieldSet(this, _EthereumProvider_options, ethereum_options_1.EthereumOptionsConfig.normalize(options), "f"));
        const wallet = (__classPrivateFieldSet(this, _EthereumProvider_wallet, new wallet_1.default(providerOptions.wallet, providerOptions.logging), "f"));
        const accounts = wallet.initialAccounts;
        const fork = providerOptions.fork.url ||
            providerOptions.fork.provider ||
            providerOptions.fork.network;
        const fallback = fork ? new fork_1.Fork(providerOptions, accounts) : null;
        const coinbase = parseCoinbase(providerOptions.miner.coinbase, accounts);
        const blockchain = new blockchain_1.default(providerOptions, coinbase, fallback);
        __classPrivateFieldSet(this, _EthereumProvider_blockchain, blockchain, "f");
        blockchain.on("ganache:vm:tx:before", event => {
            this.emit("ganache:vm:tx:before", event);
        });
        blockchain.on("ganache:vm:tx:step", event => {
            this.emit("ganache:vm:tx:step", event);
        });
        blockchain.on("ganache:vm:tx:after", event => {
            this.emit("ganache:vm:tx:after", event);
        });
        blockchain.on("ganache:vm:tx:console.log", event => {
            this.emit("ganache:vm:tx:console.log", event);
        });
        hookEventSystem(this, (enable) => {
            blockchain.toggleStepEvent(enable);
        });
        __classPrivateFieldSet(this, _EthereumProvider_api, new api_1.default(providerOptions, wallet, blockchain), "f");
    }
    async initialize() {
        await __classPrivateFieldGet(this, _EthereumProvider_blockchain, "f").initialize(__classPrivateFieldGet(this, _EthereumProvider_wallet, "f").initialAccounts);
        this.emit("connect");
    }
    /**
     * Returns the options, including defaults and generated, used to start Ganache.
     */
    getOptions() {
        return (0, lodash_clonedeep_1.default)(__classPrivateFieldGet(this, _EthereumProvider_options, "f"));
    }
    /**
     * Returns the unlocked accounts
     */
    getInitialAccounts() {
        const accounts = {};
        const wallet = __classPrivateFieldGet(this, _EthereumProvider_wallet, "f");
        const unlockedAccounts = __classPrivateFieldGet(this, _EthereumProvider_wallet, "f").unlockedAccounts;
        wallet.initialAccounts.forEach(account => {
            const address = account.address.toString();
            accounts[address] = {
                secretKey: account.privateKey.toString(),
                balance: account.balance.toBigInt(),
                unlocked: unlockedAccounts.has(address)
            };
        });
        return accounts;
    }
    send(arg1, arg2) {
        return __classPrivateFieldGet(this, _EthereumProvider_send, "f").call(this, arg1, arg2);
    }
    sendAsync(arg1, arg2) {
        __classPrivateFieldGet(this, _EthereumProvider_send, "f").call(this, arg1, arg2);
    }
    /**
     * EIP-1193 style request method
     * @param args -
     * @returns A Promise that resolves with the method's result or rejects with a CodedError
     * @EIP [1193](https://github.com/ethereum/EIPs/blob/master/EIPS/eip-1193.md)
     */
    async request(args) {
        const rawResult = await this._requestRaw(args);
        const value = await rawResult.value;
        return JSON.parse(JSON.stringify(value));
    }
    /**
     * INTERNAL. Used when the caller wants to access the original `PromiEvent`,
     * which would otherwise be flattened into a regular Promise through the
     * Promise chain.
     * @param request - the request
     */
    async _requestRaw({ method, params }) {
        __classPrivateFieldGet(this, _EthereumProvider_logRequest, "f").call(this, method, params);
        const result = await __classPrivateFieldGet(this, _EthereumProvider_executor, "f").execute(__classPrivateFieldGet(this, _EthereumProvider_api, "f"), method, params);
        const promise = result.value;
        if (promise instanceof utils_1.PromiEvent) {
            promise.on("message", data => {
                const normalizedData = JSON.parse(JSON.stringify(data));
                // EIP-1193
                this.emit("message", normalizedData);
                // legacy
                this.emit("data", {
                    jsonrpc: "2.0",
                    method: "eth_subscription",
                    params: normalizedData.data
                });
            });
        }
        const value = promise.catch((error) => {
            if (__classPrivateFieldGet(this, _EthereumProvider_options, "f").chain.vmErrorsOnRPCResponse) {
                if ((0, utils_1.hasOwn)(error, "result")) {
                    // stringify the result here
                    // TODO: not sure why the stringification is even needed.
                    error.result = JSON.parse(JSON.stringify(error.result));
                }
            }
            // then rethrow
            throw error;
        });
        return { value: value };
    }
}
exports.EthereumProvider = EthereumProvider;
_EthereumProvider_options = new WeakMap(), _EthereumProvider_api = new WeakMap(), _EthereumProvider_wallet = new WeakMap(), _EthereumProvider_executor = new WeakMap(), _EthereumProvider_blockchain = new WeakMap(), _EthereumProvider_send = new WeakMap(), _EthereumProvider_logRequest = new WeakMap(), _EthereumProvider_legacySendPayloads = new WeakMap(), _EthereumProvider_legacySendPayload = new WeakMap();
//# sourceMappingURL=provider.js.map